import React from 'react';
import { BookOpen, HelpCircle, User, ClipboardList, FileText, Youtube } from 'lucide-react';

const BottomNavigation = ({ activeTab, onTabChange }) => {
  const tabs = [
    { id: 'learn', label: 'Lernen', icon: BookOpen },
    { id: 'quiz', label: 'Quiz', icon: ClipboardList },
    { id: 'youtube', label: 'Videos', icon: Youtube },
    { id: 'help', label: 'Abos', icon: HelpCircle },
    { id: 'profile', label: 'Profil', icon: User },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-card/95 backdrop-blur-lg border-t border-border safe-area-bottom z-50">
      <div className="flex items-center justify-around h-16 max-w-lg mx-auto">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`flex flex-col items-center justify-center flex-1 h-full transition-colors duration-200 tap-highlight ${
                isActive 
                  ? 'text-primary' 
                  : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              <div className={`relative ${
                isActive ? 'transform scale-110' : ''
              } transition-transform duration-200`}>
                <Icon className={`w-5 h-5 ${
                  isActive ? 'stroke-[2.5px]' : 'stroke-[1.5px]'
                }`} />
                {isActive && (
                  <div className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full bg-primary" />
                )}
              </div>
              <span className={`text-[10px] mt-1 font-medium ${
                isActive ? 'text-primary' : ''
              }`}>
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNavigation;
